// extracted by mini-css-extract-plugin
export default {"overlay":"qA-z","bodyOpen":"rA-z","content":"sA-z","header":"tA-z","close":"uA-z","closeNoHeading":"vA-z"};